import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"
import type { AddStudentProject, StudentProject } from "@/types/projectTypes"

export function useEditProjectMutation() {
  return useGenereicMutation<StudentProject>({
    createEndpoint: (data) => ENDPOINTS.projects.edit(data.id),
    method: HTTP_METHODS.PUT,
    invalidationKeys: [QUERY_KEYS.projects.index()],
  })
}
export function useAddProjectMutation() {
  return useGenereicMutation<AddStudentProject>({
    createEndpoint: () => ENDPOINTS.projects.add(),
    method: HTTP_METHODS.POST,
    invalidationKeys: [QUERY_KEYS.projects.index()],
  })
}
export function useRemoveProjectMutation() {
  return useGenereicMutation<StudentProject>({
    createEndpoint: (data) => ENDPOINTS.projects.delete(data.id),
    method: HTTP_METHODS.DELETE,
    invalidationKeys: [QUERY_KEYS.projects.index()],
  })
}
